import { useRef } from "react";
import styled from "styled-components";
import Colors from "../../ui/global/Colors";
import TopBar from "../website/TopBar";
import Hero from "../website/Hero";
import AnimateGallery from "./components/AnimateGallery";
import RainbowButton from "../website/RainbowButton";
import CursorEffect from "../../ui/components/CursorEffect";
import Footer from "../website/Footer";
import GlobalMessage from "../pricing/GlobalMessage";

const Root = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    height: 100svh;
    background-color: ${Colors.background};
    color: ${Colors.black};
    padding: 5px 5px 0 5px;
    gap: 0px;
    overflow: hidden;
`;

const InitialContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    flex: 1;
    width: 100%;
    text-align: center;
    margin: 0;
    margin-bottom: 10px;
    gap: 20px;
    overflow-y: auto;
    overflow-x: hidden;

    /* Custom Scrollbar */
    &::-webkit-scrollbar {
        width: 8px;
    }
    &::-webkit-scrollbar-track {
        background: transparent;
    }
    &::-webkit-scrollbar-thumb {
        background: #d4d4d8;
        border-radius: 10px;
    }
    &::-webkit-scrollbar-thumb:hover {
        background: #a1a1aa;
    }
`;

const InitialButtonContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: fit-content;
    margin: 10px;
    margin-top: 30px;
    gap: 10px;
    z-index: 2;

    @media (max-width: 412px) {
        flex-direction: column;
        width: 100%;
        gap: 20px;
    }
`;

interface AnimateInitialProps {
    config: any;
    onCreateClick: () => void;
}

const AnimateInitial = ({ config, onCreateClick }: AnimateInitialProps) => {
    const scrollContainerRef = useRef<HTMLDivElement>(null);

    const handleScrollToTop = () => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };
    
    const primaryButtons = (
        <InitialButtonContainer>
            <RainbowButton 
                color='black' 
                text="Create Animation" 
                onClick={onCreateClick} 
            />
        </InitialButtonContainer>
    );

    const tabs = [
        { name: 'My Animations' },
        { name: 'Community' },
    ];

    return (
        <Root id="animate-initial-root">
            <GlobalMessage config={config} colorMode="light" />
            <TopBar type={'Animate'} colorMode='light'/> 
            <InitialContainer ref={scrollContainerRef}>
                <Hero 
                    title="AI Animator" 
                    subtitle="Create game-ready sprite sheets in any art style." 
                    subtitleSize="small"
                    colorMode='light'
                    children={primaryButtons} 
                />
                <AnimateGallery colormode="light" tabs={tabs} />
                <CursorEffect colorMode="light"/>
            </InitialContainer>
            <Footer colorMode='light' onLogoClick={handleScrollToTop} page='animation'/>
        </Root>
    );
};

export default AnimateInitial;